import { gql } from "@apollo/client";

export const ORGANISATION_FIELDS = gql`
  fragment OrganisationFields on Organization {
    id
    addressLine1
    addressLine2
    domainName
    name
    paymentTermsInDays
    postalCode
    sector
    tagList
    notes
    organizationUsers {
      id
      userId
      role
      isAdmin
      user {
        id
        email
        name
      }
    }
  }
`;

export const ORGANISATIONS_QUERY = gql`
  query GetOrganisations($filter: OrganizationFilter, $sort: OrganizationSort) {
    allOrganizations(filter: $filter, sort: $sort) {
      organizations {
        ...OrganisationFields
      }
      page
      perPage
      totalCount
    }
  }
  ${ORGANISATION_FIELDS}
`;
